<template>
  <card-dialog
    v-model="modalVisible"
  >
    <template v-slot:title>
      <v-card-title class="grey-bg px-6 py-3">
        <div>Change radio</div>
        <div class="body-1">
          {{ player.description }}
        </div>
      </v-card-title>
    </template>

    <v-card-text class="mt-5">
      <p>
        If change initiated, player will start downloading new content and playback will start.
      </p>
    </v-card-text>

    <template v-slot:actions>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          large
          :loading="submitting"
          @click="assignRadio"
        >
          Yes, start {{ radio.title }}
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>
<script>
import CardDialog from '@/components/helpers/CardDialog'
import Players from '@/services/Players'

export default {
  name: 'PlayerAssignRadio',
  components: { CardDialog },
  props: {
    radio: {
      type: Object,
      required: true
    },
    player: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    async assignRadio() {
      this.submitting = true

      try {
        await Players.assignToRadio([this.player.id], this.radio.id, true)

        this.$store.dispatch('alert', {
          text: 'Radio successfully changed',
          color: 'success'
        })

        this.$emit('success')
        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There was an error switching radio',
          color: 'error'
        })

        throw e
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
